/**
 * Why an action is illegal, finer than the rule ID: one rule often has several reasons
 * (R-SREP-01: not damaged, fired this turn, not in an own port…). Reasons are stable
 * identifiers like rule IDs — clients key their human explanations on them — and are never
 * renamed or reused.
 */
export const REASONS = [
  // Game and turn
  'gameOver',
  'invalidAction',
  'unknownUnit',
  'notYourTurn',
  'notYourUnit',
  'noDrawOffer',
  // Squadron and wind
  'groupAlreadyCast',
  'invalidGroup',
  'noSquadron',
  'windNotCast',
  'castWindFirst',
  'notInSquadron',
  'inSquadron',
  'stormDrifted',
  'becalmed',
  // Ship state
  'sunk',
  'inDock',
  'alreadyInDock',
  'onFortRepair',
  'alreadyMoved',
  'firedInPort',
  // Movement
  'notInLine',
  'tooFar',
  'blockedByLand',
  'blockedByReef',
  'ownRoyalPort',
  'enemyPort',
  'cellFull',
  'portFull',
  'diagonalSqueeze',
  'shipInTheWay',
  'notInOwnPort',
  'notInThisPort',
  // Fire
  'invalidShots',
  'noShotsLeft',
  'cannotFireInDock',
  'cannotFireOnRepair',
  'onEnemyRoyalPort',
  'fortDestroyed',
  'outOfRange',
  'lineOfFireBlocked',
  'friendlyTarget',
  'fortCannotTargetFort',
  'targetGone',
  'volleyTooFewShooters',
  // Repairs
  'notDamaged',
  'firedThisTurn',
  'alreadyRepairing',
  'enemiesInPort',
  'notYourFort',
  'wrongCrewSize',
  'crewNotInPort',
  'noRepairHere',
] as const;

export type Reason = (typeof REASONS)[number];

/** A violated rule and the reason within it; null where the check passes. */
export interface Block {
  readonly rule: string;
  readonly reason: Reason;
}

export function block(rule: string, reason: Reason): Block {
  return { rule, reason };
}
